"use client";
import Combobox from "@/components/primitives/combobox";
import { createTeamSlug, createTeamSlugFromString } from "@/utils/url";
import { Sport, Team } from "common";
import { useRouter } from "next-nprogress-bar";
import React from "react";

export default function TeamsFilter({
    sport,
  teams,
  team,
}: {
    sport: Sport;
  teams: Team[];
  team: string;
}) {
  const router = useRouter();
  const teamOptions: Option[] = [
    ...teams.map((team) => ({
      label: `${team.location ?? ""} ${team.name}`,
      value: `${team.location?.toLowerCase() ?? ""} ${team.name.toLowerCase()}`,
    })),
  ];

  return (
    <Combobox
      triggerPlaceholder="Select Team"
      align="end"
      height={12}
      value={team}
      options={teamOptions}
      onSelectItem={(v) =>
        router.push(
          createTeamSlugFromString(sport, v),
          { scroll: false }
        )
      }
    />
  );
}
